import { Form, Input, Button, Alert, Card, Tabs, Divider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { current, signInPassword, signOut } from '../../../lib/auth/actions';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const SigninForm = () => {
    const [val, progress] = signInPassword();
    const [currUser, currUserProgress] = current();

    const onFinish = (values: any) => {
        console.log('Received values of form: ', values);
        progress.value.exec(values);
    };

    const router = useRouter();

    useEffect(() => {
        currUser?.id && router.push("/console")
    }, [currUser, router]);

    useEffect(() => {
        signOut({ route: false, delay: 0 });
    }, [])

    const unauthorized = (progress.value.error as any)?.status == 401;

    return (
        <>
            {progress.value.error && <Alert type='error' message={unauthorized ? "Bad credentials" : progress.value.error?.message} />}
            <br />
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="id"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your user id',
                        }]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email or Username" />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password',
                        }]}
                >
                    <Input type="password" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Password" />
                </Form.Item>
                <Form.Item className='text-center'>
                    <br />
                    <a href="/auth/recover-password">Forgot password</a>

                    <Divider type="vertical" />
                    <b><a href="/auth/signup">Sign up</a></b>

                    <Divider type="vertical" />
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Log in
                    </Button>
                </Form.Item>
            </Form>
            {/* No username?&nbsp; */}
            {/* <a href="/waitlist">Join our waitlist</a>&nbsp;&nbsp;&nbsp;&nbsp; */}
            {/* <div className='text-center antd-row'>
                <a href="/auth/signup">Sign up</a>
                <Divider type="vertical" />
                <a href="/auth/recover-password">Forgot password</a>
            </div> */}
        </>
    );
};